export const LEFT_PANE_INIT_WIDTH = 303;
export const CENTERED_FRAME_PADDING = 20;
